"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _ui = require("@alycecom/ui");

var _services = require("@alycecom/services");

var _useTrackGiftingFlow = require("../../hooks/useTrackGiftingFlow");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var styles = {
  seeAllBatchesButton: {
    minWidth: 100
  }
};

var ShowGiftListsSection = function ShowGiftListsSection(_ref) {
  var onShow = _ref.onShow;

  var _useGetProspectingPar = (0, _services.useGetProspectingPartialBatchesQuery)({
    isSent: false,
    pagination: {
      limit: 0,
      offset: 0
    }
  }, {
    selectFromResult: function selectFromResult(result) {
      var _result$data$paginati, _result$data, _result$data$paginati2;

      return _objectSpread(_objectSpread({}, result), {}, {
        total: (_result$data$paginati = result === null || result === void 0 ? void 0 : (_result$data = result.data) === null || _result$data === void 0 ? void 0 : (_result$data$paginati2 = _result$data.pagination) === null || _result$data$paginati2 === void 0 ? void 0 : _result$data$paginati2.total) !== null && _result$data$paginati !== void 0 ? _result$data$paginati : 0
      });
    }
  }),
      paginationTotal = _useGetProspectingPar.total;

  var trackCampaignsListSeeAllBatchesButtonClicked = (0, _useTrackGiftingFlow.useCampaignsListSeeAllBatchesButtonClicked)();
  var handleClickSeeAll = (0, _react.useCallback)(function () {
    trackCampaignsListSeeAllBatchesButtonClicked();
    onShow();
  }, [trackCampaignsListSeeAllBatchesButtonClicked, onShow]);
  return /*#__PURE__*/_react.default.createElement(_material.Collapse, {
    in: !!paginationTotal,
    mountOnEnter: true,
    unmountOnExit: true
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    mb: 3,
    display: "flex",
    alignItems: "center"
  }, "You have ", paginationTotal !== null && paginationTotal !== void 0 ? paginationTotal : 0, " batch", (paginationTotal !== null && paginationTotal !== void 0 ? paginationTotal : 2) > 1 ? 'es' : '', " in progress", /*#__PURE__*/_react.default.createElement(_material.Box, {
    ml: 2
  }, /*#__PURE__*/_react.default.createElement(_ui.Button, {
    sx: styles.seeAllBatchesButton,
    borderColor: "divider",
    size: "small",
    onClick: handleClickSeeAll
  }, "See All"))));
};

var _default = ShowGiftListsSection;
exports.default = _default;